<template>
  <div class="summaryDialogContainer">
    <div class="actionActivator summary" v-ripple="isPermission" :class="{'disableSummaryBtn': !isPermission}" @click.stop="openDialog">
      履歴作成
    </div>
    <v-dialog
      v-model="descriptionDialog"
      persistent
      content-class="summaryDialog"
      max-width="750px">
      <div class="layerPopup">
        <div class="layerTit">
          履歴作成
        </div>
        <div class="consultation layerContent">
          <div class="transferLayerCon">
            <dt class="require-before summaryRequired">必須情報</dt>
            <table class="UXTbl notCenterLine">
              <colgroup>
                <col style="width:120px;" />
                <col />
              </colgroup>
              <tbody>
              <!-- 아직 평가관리하는 페이지가 존재 하지 않으므로 비표시 처리 데이터는 평균점수인 3으로 전송중 -->
              <!-- <tr>
                <th>顧客評価</th>
                <td>
                  <v-radio-group class="UXradio" hide-details row v-model="ratingScoreInput">
                    <v-radio label="5" :value="5"></v-radio>
                    <v-radio label="4" :value="4"></v-radio>
                    <v-radio label="3" :value="3"></v-radio>
                    <v-radio label="2" :value="2"></v-radio>
                    <v-radio label="1" :value="1"></v-radio>
                    <v-radio label="0" :value="0"></v-radio>
                  </v-radio-group>
                </td>
              </tr> -->
              <tr>
                <th :class="{ 'require-after' : !disableBrandCounselType}">分類カテゴリ</th>
                <td>
                  <div id="summarySelectBox" style="position: relative">
                    <div class="counselTaskBox">
                      <div class="selectBox" v-if="taskAuto">
                        <counsel-task-type
                          @updateTaskType="updateTaskType"
                          :brandId="brandId"
                          :counselType="counselType"
                          :counselDetailType="counselDetailType"
                        ></counsel-task-type>
                      </div>
                      <div class="selectBox selectEll" v-else>
                        <v-autocomplete
                          attach
                          v-model="selectedBrandCounselTypeId"
                          @change="setInputCookieData()"
                          class="UXautocomplete UXselect outline"
                          :menu-props="{contentClass:'UXautoMenu'}"
                          :items="brandCounselViewList"
                          item-text="counselTypeLine"
                          item-value="brandCounselTypeId"
                          label="分類カテゴリを選択または検索"
                          no-data-text="該当する分類カテゴリは存在しません。"
                          hide-details
                          solo
                          outline
                        ></v-autocomplete>
                      </div>
                      <div class="changeBtn">
                        <v-btn outline large class="UXbtn" @click="changeTaskType">
                          <i class="UXicon-transfer"></i>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="alignTop" style="padding-top: 18px;">タグ</th>
                <td class="tagTd">
                  <div class="UXtagInp">
                    <v-text-field
                      ref="tagInp"
                      class="tag-input"
                      v-model="tagInput"
                      placeholder="タグ入力"
                      color="6D8DFF"
                      :append-icon="tagInput && tagInput.length ? 'close': 'edit'"
                      @input="tagResize"
                      @keydown.enter.exact.prevent
                      @keyup.enter.exact="sendTag()"
                      @click:append="tagInput && tagInput.length ? removeTag() : sendTag()"
                      hide-details
                      outline
                      solo
                      maxLength="100"
                    ></v-text-field>
                    <div ref="tagHideTxt" class="hideTagText">{{tagInput}}</div>
                    <p v-for="(item, index) in tagList" :key="index" class="UXtagItem">{{item}} <i class="UXicon-close" @click="deleteTag(item)"></i></p>
                  </div>
                </td>
              </tr>
              <tr v-if="useCafe24">
                <th class="alignTop" style="padding-top: 18px;">Cafe24<br/>注文番号</th>
                <td class="tagTd">
                  <div class="UXtagInp">
                    <v-text-field
                      ref="orderInp"
                      class="tag-input"
                      style="width: 124px; min-width: 124px;"
                      v-model="orderInput"
                      placeholder="注文番号入力"
                      color="6D8DFF"
                      :append-icon="orderInput && orderInput.length ? 'close': 'edit'"
                      @input="orderResize"
                      @keydown.enter.exact.prevent
                      @keyup.enter.exact="sendOrder()"
                      @click:append="orderInput && orderInput.length ? removeOrder() : sendOrder()"
                      hide-details
                      outline
                      solo
                    ></v-text-field>
                    <div ref="orderHideTxt" class="hideTagText">{{orderInput}}</div>
                    <p v-for="(item, index) in orderNumberList" :key="index" class="UXtagItem">{{item}} <i class="UXicon-close" @click="deleteOrder(item)"></i></p>
                  </div>
                  <span class="gray-6--text">Cafe24 注文番号を入力した後、下記の相談メモを作成すると, Cafe24 管理者センター[管理者メモ]にも一緒に保存されます。</span>
                </td>
              </tr>
              <tr>
                <th class="alignTop">
                  相談メモ<br/>
                  <span class="template-name-length gray">(<span class="colorBlue">{{ contentLength }}</span>/{{ summaryDescriptionLimit }})</span>
                </th>
                <td>
                  <v-textarea
                    v-model="summaryDescription"
                    @keydown="checkTextLimit($event,'summaryDescription',summaryDescriptionLimit)"
                    @keyup="checkTextLimit($event,'summaryDescription',summaryDescriptionLimit)"
                    hide-details
                    no-resize
                    outline
                    height="230"
                    class="UXtextarea"
                    placeholder="相談メモを入力してください。"
                  ></v-textarea>
                </td>
              </tr>
              <tr v-if="useCafe24 && orderNumberList && orderNumberList.length > 0">
                <th>重要メモ</th>
                <td class="memoTd">
                  <v-checkbox
                    v-model="starredType"
                    id="starredType"
                    class="UXcheckbox gray"
                    label="チェック時 Cafe24 管理者センター[管理者メモ]に[重要]バッジが表示されます。"
                    solo
                    hide-details
                  ></v-checkbox>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="subTit" v-if="summaryCustom.length">
              追加の相談記録を入力
            </div>
            <table class="UXTbl notCenterLine customSummaryTbl" v-if="summaryCustom.length">
              <colgroup>
                <col style="width: 110px"/>
                <col style="width: 235px"/>
                <col style="width: 110px"/>
              </colgroup>
              <tbody>
              <tr v-for="(customItem, index) in summaryCustom" :key="index">
                <th>
                  {{ customItem[0].title  }}
                  <span v-if="customItem[0].type === 'TEXT'">(<span>{{ customItem[0].value ? customItem[0].value.length : 0 }}</span>/30)</span>
                </th>
                <td>
                  <v-text-field
                    v-if="customItem[0].type === 'TEXT'"
                    v-model="customItem[0].value"
                    :placeholder="customItem[0].placeholder"
                    class="UXinput UXicon-edit"
                    maxLength="30"
                    outline
                    solo
                  ></v-text-field>
                  <v-select
                    v-if="customItem[0].type === 'SELECT'"
                    v-model="customItem[0].value"
                    :items="customItem[0].items"
                    item-text="value"
                    item-value="code"
                    class="UXselect"
                    :placeholder="customItem[0].placeholder"
                    hide-details
                    outline
                    solo
                    no-data-text="データがありません。"
                  ></v-select>
                </td>

                <th v-if="customItem[1]">
                  {{ customItem[1].title  }}
                  <span v-if="customItem[1].type === 'TEXT'">(<span>{{ customItem[1].value ? customItem[1].value.length : 0 }}</span>/30)</span>
                </th>
                <td v-if="customItem[1]">
                  <v-text-field
                    v-if="customItem[1].type === 'TEXT'"
                    v-model="customItem[1].value"
                    :placeholder="customItem[1].placeholder"
                    class="UXinput UXicon-edit"
                    maxLength="30"
                    outline
                    solo
                  ></v-text-field>
                  <v-select
                    v-if="customItem[1].type === 'SELECT'"
                    v-model="customItem[1].value"
                    :items="customItem[1].items"
                    item-text="value"
                    item-value="code"
                    class="UXselect"
                    :placeholder="customItem[1].placeholder"
                    hide-details
                    outline
                    solo
                    no-data-text="データがありません。"
                  ></v-select>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="cenBtn">
              <v-btn outline round large class="UXbtn widthAuto" :disabled="loading" @click="closeDescriptionDialog">キャンセル</v-btn>
              <v-btn round dark large color="#ff8c8c" class="UXbtn widthAuto" :loading="loading" :disabled="loading" @click="summaryChatRoom">確認</v-btn>
            </div>
          </div>
        </div>
        <div class="layerClose">
          <v-btn flat icon @click="closeDescriptionDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {isValidOrderId} from '../../../menus/cafe24/util/baseUtil'
import OrderListSearchType from '../../../menus/cafe24/enums/OrderListSearchType'
import counselTaskType from '@/components/CounselTaskType'
import eventType from '@/components/operation/enums/eventType'
import helper from 'util/helpers'
import eventBus from '@/event_bus'
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'summary_dialog',
  props: ['brandId', 'agentId', 'chatRoomId', 'orderList', 'isPermission'],
  created () {
    this.searchCounselTypes()
  },
  computed: {
    ...mapGetters([
      'summaryChatRoomList',
      'mallId',
      'useCafe24'
    ]),
    disableBrandCounselType () {
      return this.brandCounselViewList.length === 0
    }
  },
  data () {
    return {
      loading: false,
      descriptionDialog: false,
      ratingScoreInput: 3,
      selectedBrandCounselTypeId: null,
      brandCounselViewList: [],
      summaryDescription: '',
      starredType: false,
      tagInput: '',
      tagList: [],
      orderInput: '',
      orderNumberList: [],
      contentLength: 0,
      summaryDescriptionLimit: 5000,
      summaryCustom: [],
      summaryOptions: [],
      isCheckSummaryDesc: true,
      taskAuto: false,
      counselType: 'TALK_MAIL',
      counselDetailType: 'TALK_MAIL',
      cookieSummaryArray: []
    }
  },
  components: {
    counselTaskType
  },
  watch: {
    summaryDescription () {
      this.contentLength = this.summaryDescription.length
    },
    orderList: {
      deep: true,
      handler: function () {
        this.orderNumberList = this.orderList
      }
    },
    descriptionDialog (val) {
      if (!val) {
        this.init()
      } else {
        this.initCookieData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'addCompletedChatRoom',
      'removeSummaryChatRoom',
      'deleteTabChatRoom'
    ]),
    init () {
      this.ratingScoreInput = 3
      this.selectedBrandCounselTypeId = null
      this.tagInput = ''
      this.tagList = []
      this.orderInput = ''
      this.orderNumberList = []
      this.summaryDescription = ''
    },
    openDialog () {
      if (!this.isPermission) return
      this.descriptionDialog = true
      this.fetchSummaryCustomOption()
    },
    closeDescriptionDialog () {
      this.descriptionDialog = false
      this.removeTag()
      this.orderResize()
    },
    searchCounselTypes () {
      this.axios.get('/api/brand/getBrandCounselTypeLeafs', {
        params: {
          brandId: this.brandId
        }
      }).then(result => {
        if (result.data.code !== 0) throw result.data.message
        this.brandCounselViewList = result.data.data
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    summaryChatRoom () {
      if (this.selectedBrandCounselTypeId === null || this.selectedBrandCounselTypeId.length === 0) {
        this.$alertMsg('分類カテゴリを選択してください。</br>分類カテゴリ登録してない場合ご登録の上、ご使用ください。')
        return false
      }

      if (this.useCafe24 && this.orderNumberList && this.orderNumberList.length > 0) {
        for (let i = 0; i < this.orderNumberList.length; i++) {
          if (!isValidOrderId(this.orderNumberList[i], OrderListSearchType.ORDER_NO)) {
            this.$alertMsg('無効な注文番号です。<br/>Cafe24 注文番号を確認してもう一度お試しください。')
            return
          }
        }

        if ((!this.summaryDescription.length || this.summaryDescription.length < 1) && this.isCheckSummaryDesc) {
          return this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: `<dl class="txt"><dd>相談メモを作成せずに保存しますか？<br/>(作成された相談メモは、Cafe24管理者センター[管理者メモ]<br/>にも一緒に保存されます。)</dd></dl>`,
            getBtnCount: 2,
            getButtonEvent: () => {
              setTimeout(() => {
                this.isCheckSummaryDesc = false
                this.summaryChatRoom()
              }, 1000)
            }
          })
        }
      }

      if (!this.isCheckSummaryDesc) {
        this.isCheckSummaryDesc = true
      }

      if (this.loading) return

      let summaryCustomValues = null
      if (this.summaryCustom.length) {
        let summaryCustomOptionArray = []

        const summaryOptionObject = {}
        this.summaryOptions.forEach(option => {
          summaryOptionObject[option.code] = option
        })

        this.summaryCustom.flatMap(item => item).forEach(item => {
          if (item && item.value) {
            if (item.type === 'SELECT') {
              const findItem = (summaryOptionObject && summaryOptionObject[item.code]) || {}
              if (findItem && findItem.items) {
                const itemInItems = findItem.items.find(i => i.code === item.value)
                if (itemInItems) {
                  summaryCustomOptionArray.push({
                    optionId: item.id,
                    optionCode: item.code,
                    title: item.title,
                    type: item.type,
                    value: itemInItems.value || null,
                    itemId: itemInItems.id,
                    itemCode: itemInItems.code
                  })
                }
              }
            } else {
              summaryCustomOptionArray.push({
                optionId: item.id,
                optionCode: item.code,
                title: item.title,
                type: item.type,
                value: item.value || null
              })
            }
          }
        })

        if (summaryCustomOptionArray.length) {
          summaryCustomValues = summaryCustomOptionArray
        }
      }

      this.loading = true
      this.axios.post('/api/chat/summary', {
        agentId: this.agentId,
        chatRoomId: this.chatRoomId,
        description: this.summaryDescription,
        brandCounselTypeId: this.disableBrandCounselType ? null : this.selectedBrandCounselTypeId,
        ratingScore: this.ratingScoreInput,
        tags: this.tagList,
        summaryCustomValues
      }).then(res => {
        if (res.data.code !== 0) throw res.data.message
        const selectedChatRoom = helper.findByChatRoomId(this.summaryChatRoomList, this.chatRoomId)
        this.addCompletedChatRoom(selectedChatRoom)
        this.removeSummaryChatRoom(selectedChatRoom)
        this.deleteTabChatRoom(selectedChatRoom)
        this.closeDescriptionDialog()
        eventBus.$emit('customer-history-initialize')
        eventBus.$emit(eventType.TAKE_OVER_MESSAGE_CLEAR)
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .then(() => this.updateCafe24OrderMemo())
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.loading = false
        })
    },
    updateCafe24OrderMemo () {
      if (this.useCafe24 && this.orderNumberList && this.orderNumberList.length > 0) {
        this.axios.post('/api/brand/cafe24/orderMemo/create', {
          brandId: this.brandId,
          chatRoomId: this.chatRoomId,
          content: this.summaryDescription,
          orderIds: this.orderNumberList,
          starredType: this.starredType ? 'T' : 'F',
          shopNo: 1
        }).then(res => {
          if (res.data.code !== 0) throw res.data.message
        }, () => this.$alertMsg(this.$const.SYS_ERR))
          .catch(errorMsg => this.$alertMsg(errorMsg))
      }
    },
    sendTag () {
      let inputValue = this.tagInput.replace(/ /g, '')
      if (inputValue && this.tagList.indexOf(inputValue) === -1) {
        this.tagList.push(inputValue)
        this.removeTag()
      }
      this.setInputCookieData()
    },
    removeTag () {
      this.tagInput = ''
      this.tagResize()
    },
    deleteTag (tag) {
      this.tagList.splice(this.tagList.indexOf(tag), 1)
    },
    tagResize () {
      setTimeout(() => {
        if (this.$refs.tagInp && this.$refs.tagInp.$el) {
          this.$refs.tagInp.$el.style.width = (this.$refs.tagHideTxt.offsetWidth + 60) + 'px'
        }
      })
    },
    sendOrder () {
      let inputValue = this.orderInput.replace(/ /g, '')
      if (inputValue && this.orderNumberList.indexOf(inputValue) === -1) {
        this.orderNumberList.push(inputValue)
        this.removeOrder()
      }
    },
    removeOrder () {
      this.orderInput = ''
      this.orderResize()
    },
    deleteOrder (tag) {
      this.orderNumberList.splice(this.orderNumberList.indexOf(tag), 1)
    },
    orderResize () {
      setTimeout(() => {
        if (this.$refs.orderInp && this.$refs.orderInp.$el) {
          this.$refs.orderInp.$el.style.width = (this.$refs.orderHideTxt.offsetWidth + 60) + 'px'
        }
      })
    },
    checkTextLimit (event, key, limitCnt) {
      // 방향키 37~40 , backspace 8, delete key 46
      const isAllowKeyCodes = [8, 37, 38, 39, 40, 46]
      // 복사,붙혀넣기,전체선택
      const copyPaste = ((event.ctrlKey || event.metaKey) && (event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 65))
      const allowed = isAllowKeyCodes.includes(event.keyCode) || copyPaste
      if (!allowed) {
        if (this[key] && this[key].length > limitCnt) {
          this[key] = this[key].substr(0, limitCnt)
        }
        if (this[key] && this[key].length >= limitCnt) {
          event.preventDefault()
          this.$toasted.clear()
          this.$toasted.error('最大入力文字数を超えました。')
        }
      }
      this.setInputCookieData()
    },
    twoDepthArrayFromArray (array = [], maxLength = 0) {
      if (!array.length || !maxLength) {
        return []
      }
      let oneDepthArr = []
      let twoDepthArr = []
      array.forEach(item => {
        twoDepthArr.push(item)
        if (twoDepthArr.length === maxLength) {
          oneDepthArr.push(twoDepthArr)
          twoDepthArr = []
        }
      })

      return oneDepthArr
    },
    fetchSummaryCustomOption () {
      try {
        this.axios.get(`/api/chat/${this.chatRoomId}/summary-options`)
          .then((result) => {
            if (result.data.code === 0) {
              const summaryOptions = result.data.data || []
              this.summaryOptions = summaryOptions
              this.summaryCustom = this.twoDepthArrayFromArray(summaryOptions, 2)
            }
          }).catch(errorMsg => this.$alertMsg(errorMsg))
      } catch (e) {
        console.log(e)
      }
    },
    getItemPlaceholder ({ title = '', type = 'TEXT' }) {
      if (!title) {
        return ''
      }

      switch (type) {
        case 'TEXT':
          return `${title}を作成してください。`
        case 'SELECT':
          return `${title}を選択してください。`
      }
    },
    updateTaskType (type) {
      this.selectedBrandCounselTypeId = type.sclass.id || type.lclass.id || type.gclass.id
      this.setInputCookieData()
    },
    changeTaskType () {
      this.taskAuto = !this.taskAuto
      this.selectedBrandCounselTypeId = null
    },
    setInputCookieData () {
      if (Object.keys(this.cookieSummaryArray).length !== 0) {
        let findCookieData = this.cookieSummaryArray.find(data => data.chatroomId === this.chatRoomId)
        if (findCookieData) {
          findCookieData.summaryDescription = this.summaryDescription
          findCookieData.selectedBrandCounselTypeId = this.selectedBrandCounselTypeId
          findCookieData.tagList = this.tagList
          this.$cookies.set('summaryArray', this.cookieSummaryArray)
        } else {
          this.setCookieData()
        }
      } else {
        this.setCookieData()
      }
    },
    initCookieData () {
      if (this.cookieSummaryArray) {
        let findCookieData = this.cookieSummaryArray.find(data => data.chatroomId === this.chatRoomId)
        if (findCookieData) {
          this.summaryDescription = findCookieData.summaryDescription
          this.selectedBrandCounselTypeId = findCookieData.selectedBrandCounselTypeId
          this.tagList = findCookieData.tagList
        }
      }
    },
    setCookieData () {
      let summaryData = {
        chatroomId: this.chatRoomId,
        summaryDescription: this.summaryDescription,
        selectedBrandCounselTypeId: this.selectedBrandCounselTypeId,
        tagList: this.tagList
      }
      this.cookieSummaryArray.push(summaryData)
      this.$cookies.set('summaryArray', this.cookieSummaryArray)
    }
  }
}
</script>

<style lang="scss">
.summaryDialogContainer {
  .disableSummaryBtn {
    opacity: 0.3;
    cursor: auto!important;
  }
}

.actionActivator.disableSummaryBtn {
  opacity: 0.3;
  cursor: auto!important;
}

.summaryDialog {
  .template-name-length {
    font-size: 12px !important;
    line-height: 16px !important;
  }
  .consultation {
    .template-name-length {
      font-size: 12px !important;
      line-height: 16px !important;
    }

    .gray {
      color: #919191;
    }

    .alignTop {
      vertical-align: top !important;
    }

    .tagTd {
      padding-right: 7px !important;
      padding-bottom: 0;
      span {
        font-size: 12px;
        line-height: 16px;
      }
    }

    .memoTd {
      height: 44px;
      .UXcheckbox {
        flex: 0;
      }
    }

    .summaryRequired {
      color: #919191;
      font-size: 12px;
      text-align: right;
      padding-top: 5px;
    }

    .UXtagItem {
      word-break: break-word;
    }

    .subTit {
      padding-top: 30px;
      padding-bottom: 5px;
      font-weight: bold;
      color: #414141;
      font-size: 14px;
      line-height: 20px;
    }

    .customSummaryTbl tbody tr th {
      > span {
        display: block;
        font-size: 12px;
        color: #919191;
        line-height: 16px;

        > span {
          color: $pb_6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/summary_dialog.vue